module.exports = __webpack_public_path__ + "pc/img/body_basic-7.edba437c.png";